
<modal :state="state" :index="index" @toggle-modal="emitHideModal($event)">
  <div>
    <h3 class="modal-title">{{title}}</h3>
    <slot></slot>
    <slot name="body-text"></slot>
    <div class="cta">
      <button type="button" @click="cancel" class="btn block grey outline">Cancel</button>
      <button type="button" @click="confirm" class="btn block red">Delete</button>
    </div>
  </div>
</modal>
